import { AmlScanEntity, LatestAmlReport } from "../../api/models/fraud.models";

function safeJsonParse(jsonString: string): any {
  try {
    return JSON.parse(jsonString);
  } catch (error) {
    console.warn('Failed to parse JSON:', error);
    return jsonString;
  }
}

export function parseTransactionData(transaction: AmlScanEntity): AmlScanEntity<LatestAmlReport> {
  return {
    ...transaction,
    latestAmlReport: transaction.latestAmlReport ? safeJsonParse(transaction.latestAmlReport) : transaction.latestAmlReport,
    providerReports: transaction.providerReports && transaction.providerReports.length > 0 
      ? transaction.providerReports.map((report) => ({
          ...report,
          data: safeJsonParse(report.data)
        }))
      : transaction.providerReports || []
  } as AmlScanEntity<LatestAmlReport>;
}

export function parseTransactionsData(transactions: AmlScanEntity[]): ReturnType<typeof parseTransactionData>[] {
  return transactions.map(transaction => parseTransactionData(transaction));
}
